import { ErrorHandler, Injectable } from '@angular/core'; 
import * as Sentry from '@sentry/angular';

@Injectable() export class SentryErrorHandler implements ErrorHandler { 

handleError(error: any): void { 
Sentry.captureException(error); 
throw error; 
}
 
}
